import { UserQualificationBase } from "domain/model/base";

export default class UserQualification extends UserQualificationBase {};
